import { TranslateFn } from '../../../hooks/context/useTranslate';
import { FilterError } from '../../../types/types';
import { MaxLengthIssue } from '../types';
import resolveMaxLengthIssue from './resolveMaxLengthIssue';

const MAX_LENGTH_ERROR_KEYS: Record<MaxLengthIssue, string> = {
  notANumber: 'export.maxLengthNotANumber',
  invalid: 'export.maxLengthInvalid',
};

const resolveMaxLengthError = (
  maxLength: string,
  t: TranslateFn
): FilterError => {
  const issue = resolveMaxLengthIssue(maxLength);

  if (issue === null) {
    return null;
  }

  return [t(MAX_LENGTH_ERROR_KEYS[issue])];
};

export default resolveMaxLengthError;
